import React from 'react';
import { ITastingMenu } from '../../models/iTastingMenu';
import AllergensList from '../laCarteMenu/AllergensList';

export interface TastingMenuProps {
    menu?: ITastingMenu
    price?: string;
    openAllergensListModal: any;
}
function TastingMenu(props: TastingMenuProps) {
    if (!!props.menu)
        return (
            <div>
                <div className='menu-title'>Menù Degustazione</div>

                <div className='menu-content dish-description text-justify' dangerouslySetInnerHTML={{ __html: props.menu.menu }} >
                </div>
                <div className='tasting-allergens-menu-title dish-description'>
                    Allergeni
                </div>
                <div className='tasting-allergens-menu-content'>
                    <AllergensList onClick={props.openAllergensListModal} allergens={props.menu.allergens} />
                </div>

                <div className='menu-content'>

                    <div className='flex-end-center '>
                        <div className='text-end'>

                            <div className='tasting-price'>
                                {props.price}€
                            </div>
                            <div className='dish-description'>
                                *coperto e bevande escluse
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    else
        return <></>
}

export default TastingMenu;